export default __webpack_public_path__ + "static/media/photo--lg--26.8f7e16d5.jpg";